'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Date Format.
 */ const date = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
};

exports.default = date;
//# sourceMappingURL=date.js.map
